document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile drawer ---------- */
  var menuToggle = document.getElementById('MenuToggle');
  var menuClose = document.getElementById('MenuClose');
  var drawer = document.getElementById('MobileDrawer');
  if (menuToggle && drawer) {
    menuToggle.addEventListener('click', function () {
      drawer.classList.add('open');
      menuToggle.setAttribute('aria-expanded', 'true');
    });
  }
  if (menuClose && drawer) {
    menuClose.addEventListener('click', function () {
      drawer.classList.remove('open');
      menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) drawer.classList.remove('open');
    });
  }

  /* ---------- Search panel ---------- */
  var searchToggle = document.getElementById('SearchToggle');
  var searchPanel = document.getElementById('SearchPanel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var isHidden = searchPanel.hasAttribute('hidden');
      if (isHidden) {
        searchPanel.removeAttribute('hidden');
        searchToggle.setAttribute('aria-expanded', 'true');
        var input = searchPanel.querySelector('input');
        if (input) input.focus();
      } else {
        searchPanel.setAttribute('hidden', '');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Product media thumbnails ---------- */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.getElementById('ProductFeaturedImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) {
        // Shopify's image_tag adds a srcset/sizes attribute for responsive
        // images; the browser prefers that over src, so it must be cleared
        // whenever we swap the visible image via JS, or the click appears
        // to do nothing.
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = thumb.getAttribute('data-media-src');
      }
    });
  });

  /* ---------- Variant selection -> update price / variant id ---------- */
  var optionSelects = document.querySelectorAll('.product-option-select');
  var variantIdInput = document.getElementById('ProductVariantId');
  var addToCartBtn = document.getElementById('AddToCart');
  var buyNowBtn = document.getElementById('BuyNow');
  var priceEl = document.getElementById('ProductPrice');

  function moneyFormat(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function updateVariant() {
    if (!window.__productVariants || optionSelects.length === 0) return;
    var selected = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
    var match = window.__productVariants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
      return opts.every(function (o, i) { return o === selected[i]; });
    });
    if (match) {
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) {
        var html = '<span>' + moneyFormat(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="old">' + moneyFormat(match.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !match.available;
        addToCartBtn.textContent = match.available ? 'Dodaj do koszyka' : 'Niedostępny';
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = !match.available;
      }
    }
  }
  optionSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });

  /* ---------- AJAX add to cart ---------- */
  var productForm = document.getElementById('ProductForm');
  var toast = document.getElementById('CartToast');
  var cartCount = document.getElementById('CartCount');

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2500);
  }

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var isBuyNow = e.submitter && e.submitter.name === 'checkout';
      var formData = new FormData(productForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          if (item.status) {
            // Shopify returns an error object (e.g. sold out) with a status code
            throw new Error(item.description || 'Nie udało się dodać produktu.');
          }
          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }
          return fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              if (cartCount) cartCount.textContent = cart.item_count;
              showToast('Dodano do koszyka');
            });
        })
        .catch(function (err) {
          showToast(err.message || 'Nie udało się dodać produktu. Spróbuj ponownie.');
        });
    });
  }
});
